import axios from 'axios';
import config from '../config';

// Create API instance
const API = axios.create({
  baseURL: config.API_URL,
});

// Add token interceptor
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export const searchHotels = async (latitude, longitude, radius = 5) => {
  try {
    const response = await API.get('/amadeus/hotels', {
      params: {
        latitude,
        longitude,
        radius
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error searching hotels:', error);
    throw error;
  }
};

export const getHotelDetails = async (hotelId) => {
  try {
    const response = await API.get(`/amadeus/hotels/${hotelId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting hotel details:', error);
    throw error;
  }
};

export const searchHotelOffers = async (hotelId, checkInDate, checkOutDate, adults = 1) => {
  try {
    const response = await API.get(`/amadeus/hotels/${hotelId}/offers`, {
      params: {
        checkInDate,
        checkOutDate,
        adults
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error searching hotel offers:', error);
    throw error;
  }
};

export const searchCars = async (latitude, longitude, radius = 5) => {
  try {
    const response = await API.get('/amadeus/cars', {
      params: {
        latitude,
        longitude,
        radius
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error searching cars:', error);
    throw error;
  }
};
